import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import invoices from './modules/invoices';
import createPersistedState from 'vuex-persistedstate'
import viewState from './modules/viewState'
import task from './modules/tasks'
import communication from './modules/communication';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    user,
    invoices,
    task,
    viewState,
    communication
  },
  strict: debug,
  plugins: [createPersistedState({
    paths: ['user','viewState', 'communication.containerState'],
  })]
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/store/index.ts